import { IErrorMessage } from '@shared/hooks/use-error-message';

export const seriesErrorMessages: IErrorMessage = {
  title: {
    required: 'validation_title_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  description: {
    required: 'validation_description_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  date: {
    required: 'validation_date_required'
  },
  genres: {
    required: 'validation_genres_required'
  }
};

export const seasonErrorMessages: IErrorMessage = {
  title: {
    required: 'validation_title_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  seasonNumber: {
    required: 'validation_season_number_required'
  }
};

export const episodeErrorMessages: IErrorMessage = {
  title: {
    required: 'validation_title_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  description: {
    required: 'validation_description_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  url: {
    required: 'validation_url_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  image: {
    required: 'validation_image_required'
  }
};
